import { library, dom } from '@fortawesome/fontawesome-svg-core';
import * as solidIcon from '@fortawesome/free-solid-svg-icons';

// Please maintain alphabetical order of icons for sanity sake
function registerSiteIcons () {
	library.add(
		solidIcon.faChevronDown,
		solidIcon.faChevronUp,
		solidIcon.faExclamationTriangle
	);

	// Replace any existing <i> tags with <svg> and set up a MutationObserver to
	// continue doing this as the DOM changes.
	dom.watch();
}

export default {
	registerSiteIcons
};
